import { Dashboard } from "@/components/dashboard/Dashboard/Dashboard";
import { VStack } from "@/components/layout/VStack";
import { useEffect, useState } from "react";
import type { ApiErrorLog } from "@shared/types/models";
import { useErrorLogs } from "../hooks/errorLogs/useErrorLogs";
import { ErrorLogsTable } from "../components/errorLogs/ErrorLogsDataTable";
import { ViewErrorLogSheet } from "../components/errorLogs/ViewErrorLogSheet";

const ErrorLogs = () => {
  const [logs, setLogs] = useState<ApiErrorLog[] | null>(null);
  const [viewing, setViewing] = useState<{
    open: boolean;
    log: ApiErrorLog | null;
  }>({ open: false, log: null });

  const { loading, loadAllErrorLogs, deleteErrorLog } = useErrorLogs();

  useEffect(() => {
    loadAllErrorLogs(setLogs);
  }, []);

  const onView = (id: string) => {
    const log = logs?.find((l) => l._id === id) ?? null;
    if (!log) return;
    setViewing({ open: true, log });
  };

  const closeSheet = () => {
    setViewing((prev) => ({ ...prev, open: false }));
  };

  const onDelete = async () => {
    if (!viewing.log) return;
    const ok = await deleteErrorLog(viewing.log._id);
    if (!ok) return;
    setLogs((prev) =>
      prev ? prev.filter((l) => l._id !== viewing.log!._id) : prev,
    );
    closeSheet();
  };

  return (
    <Dashboard activePage="/error-logs">
      <VStack>
        <h2
          style={{
            fontSize: "var(--text-2xl)",
            lineHeight: "var(--line-height-2xl)",
            fontWeight: "var(--font-bold)",
          }}
        >
          Error Logs
        </h2>
        <p style={{ color: "var(--muted-foreground)" }}>
          Server errors captured over the last 14 days. Entries auto-expire.
        </p>
      </VStack>
      {loading.logs && !logs ? (
        <p style={{ color: "var(--muted-foreground)" }}>Loading error logs...</p>
      ) : (
        <ErrorLogsTable data={logs ?? []} onView={onView} />
      )}
      {viewing.log && (
        <ViewErrorLogSheet
          log={viewing.log}
          open={viewing.open}
          onOpenChange={(open) =>
            setViewing((prev) => ({ ...prev, open }))
          }
          deleting={loading.deleting}
          onDelete={onDelete}
        />
      )}
    </Dashboard>
  );
};

export default ErrorLogs;
